export default __webpack_public_path__ + "static/0313-2aee9f06f6eb064f5250917bd295a26a.png";